import { h } from 'preact'
import { useState } from 'preact/hooks'
import { i18n } from 'i18n/i18n'

import { Domains } from 'services/domains-api'

export interface MainCalculatorContinueButtonProps {
  hrefLink: string
  login: Domains['login']
  registry: Domains['registry']
}

export const MainCalculatorContinueButton = ({ hrefLink, login, registry }: MainCalculatorContinueButtonProps) => {
  const [isOpen, setOpen] = useState(false)

  const closeDropdownOnOutside = (event: MouseEvent): void => {
    const currentTarget = event.currentTarget as HTMLDivElement
    const target = event.target as Node

    if (!currentTarget.contains(target)) {
      setOpen(false)
    }
  }

  const toggleDropdown = (): void => {
    setOpen(!isOpen)
  }

  // TODO: for A/B testing IKWT-4203
  const shouldShowHrefLink = true

  return (
    <div className="hero-form__section-with-big-button">
      <div className="hero-form__section-with-big-button-inner">
        <div
          className="hero-form-dropdown-button"
          onClick={(event) => closeDropdownOnOutside(event)}
        >
          <div className="hero-form-dropdown-button__button">
            {shouldShowHrefLink ? (
              <a
                href={hrefLink}
                className="bem-button button is-bold is-big-in-hero-form chevron-right"
                data-calc-submit
                data-track-click="anchor-button"
              >
                {i18n('calculatorForegin.continueButton')}
              </a>
            ) : (
              <div
                className="bem-button button is-bold is-big-in-hero-form"
                onClick={toggleDropdown}
              >
                {i18n('calculatorForegin.continueButton')}
              </div>
            )}
          </div>
          {isOpen && (
            <div className="hero-form-dropdown-button__menu">
              <div className="hero-form-dropdown-button__menu-inner">
                <div className="hero-form__login-question">
                  <div className="hero-form__final-buttons">
                    <a
                      href={registry}
                      className="hero-form__big-button-link"
                    >
                      <button
                        type="button"
                        className="button is-bold is-big-in-hero-form for-final-button is-secondary"
                      >
                        {i18n('continueButton.createAccount')}
                      </button>
                    </a>
                    <a
                      href={login}
                      className="hero-form__big-button-link"
                    >
                      <button
                        type="button"
                        className="button is-bold is-big-in-hero-form for-final-button is-secondary"
                      >
                        {i18n('continueButton.logIn')}
                      </button>
                    </a>
                  </div>
                  <div className="hero-form__step-3-text is-below-buttons">
                    {i18n('continueButton.check')}{' '}
                    <a
                      href="#dlaczego-warto"
                      className="bem-text-link is-bold"
                    >
                      {i18n('continueButton.checkWhyWorth')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
